/* Traduction des refus Payline/Monext en messages lisibles.
 *
 * Le serveur remonte le verdict de la banque sous une forme brute, du type
 * « PAYLINE_01110 » ou « Le paiement a échoué: 01110 ». Affiché tel quel, le
 * golfeur voit un code qui ne lui dit rien (constat de la campagne du 30/07 :
 * « Erreur inconnue » puis un code nu). On mappe ici les codes connus vers un
 * message actionnable, et on laisse passer inchangé tout message qui ne porte pas
 * de code Payline (pour ne pas écraser les erreurs applicatives légitimes).
 */

// Codes Monext/Payline rencontrés en production et homologation (cf. campagne
// paiement du 30/07 et docs/monext). La liste est volontairement courte : un code
// inconnu retombe sur un message de refus générique, jamais sur le code brut.
const MESSAGES = {
  '01110': 'Votre banque a refusé le paiement. Vérifiez votre plafond ou contactez votre banque.',
  '03003': 'Paiement refusé par votre banque.',
  '03022': 'Authentification 3-D Secure refusée ou annulée.',
  '02301': 'Paiement refusé.',
  '02319': 'Paiement abandonné.',
  '02324': 'Paiement abandonné.',
  '01131': 'Une authentification 3-D Secure est requise. Veuillez réessayer.',
};

const DEFAULT_REFUSED = 'Le paiement a été refusé. Veuillez réessayer ou utiliser une autre carte.';

/* Extrait un code numérique Payline d'un message brut, qu'il soit préfixé
 * « PAYLINE_ » ou introduit par « : » (forme « Le paiement a échoué: 01110 »). */
const extractPaylineCode = (message) => {
  if (!message) return null;
  const match = String(message).match(/(?:PAYLINE_|:\s*)(\d{4,5})\b/);
  return match ? match[1] : null;
};

/* Renvoie un message lisible si `message` porte un code Payline, sinon le
 * message d'origine inchangé. Sûr sur null/undefined et sur un objet Error. */
export const translatePaylineError = (message) => {
  const raw = message && message.message ? message.message : message;
  const code = extractPaylineCode(raw);
  if (!code) return raw;
  return MESSAGES[code] || DEFAULT_REFUSED;
};

export default translatePaylineError;
